import React from 'react';
import { useTheme } from 'styled-components';

import useBreakpoint from 'Common/hooks/useBreakpoint';

import type { EventsVariants } from 'Theme/types/components.type';

import { ArrowLinkProps } from 'Elements/Link/Arrow';

import {
    Container,
    TopBar,
    Heading,
    Inner,
    InfoWrapper,
    StyledIcon,
    Subline,
    Text,
    EventItem,
    EventDate,
    EventDateMonth,
    EventLocationWrapper,
    EventLocation,
    EventLink
} from './Vertical.styled';

export interface Props {
    id?: string;
    heading: string;
    icon: React.ElementType;
    subline: string;
    text: string;
    events: {
        id: string;
        type: string;
        date: Date;
        location: string;
        link: ArrowLinkProps;
    }[];
    variant: EventsVariants;
}

const BoxList: React.FC<Props> = props => {
    const { id = '', heading, icon, subline, text, events, variant } = props;

    const dateOptionsDay: Intl.DateTimeFormatOptions = {
        weekday: 'long'
    };

    const dateOptionsMonth: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long'
    };

    const { breakpoints } = useTheme();
    const isLargeBreakpoint = useBreakpoint(breakpoints.large.value);

    return (
        <Container id={id ? `c-boxlist-events-${id}` : 'c-boxlist-events'}>
            <TopBar>
                <Heading $variant={variant}>{heading}</Heading>
            </TopBar>
            <Inner>
                <InfoWrapper>
                    <StyledIcon as={icon} />
                    <div>
                        <Subline>{subline}</Subline>
                        <Text>{text}</Text>
                    </div>
                </InfoWrapper>
                {events.length &&
                    events.map(event => {
                        const day = event.date.toLocaleString('en-GB', dateOptionsDay);
                        const month = event.date
                            .toLocaleString('en-GB', dateOptionsMonth)
                            .replace(',', '');
                        return (
                            <EventItem
                                key={event.id}
                                id={event.id}
                                className={`c-boxlist-events-item ${event.type}`}
                                $variant={variant}
                            >
                                <EventDate>
                                    {isLargeBreakpoint ? day : `${day} ${month}`}
                                    {isLargeBreakpoint && <EventDateMonth>{month}</EventDateMonth>}
                                </EventDate>
                                <EventLocationWrapper>
                                    <EventLocation>{event.location}</EventLocation>
                                </EventLocationWrapper>
                                <EventLink {...event.link} variant="text" />
                            </EventItem>
                        );
                    })}
            </Inner>
        </Container>
    );
};

export default BoxList;
